module.exports = __webpack_public_path__ + "resources/img/img_cubrid_02.6ee81f10d41cabb55c1a23d78679800e.png";